import { getEntities, getEntity } from "../../api-client";

export const getLivestreams = async () => {
    const response = await getEntities("livestream");

    // parse datetimes
    response.forEach((livestream) => {
        if (livestream.startDate) {

            livestream.startDate = new Date(response.startDate.replace("Z", ""));
        }

        if (livestream.endDate) {
            livestream.endDate = new Date(response.endDate.replace("Z", ""));
        }
    });

    return response;
}

export const getLivestream = async (id) => {
    const response = await getEntity("livestream", id);

    // parse datetimes
    if (response.startDate) {
        response.startDate = new Date(response.startDate.replace("Z", ""));
    }

    if (response.endDate) {
        response.endDate = new Date(response.endDate.replace("Z", ""));
    }

    return response;
}
